export default __webpack_public_path__ + "static/media/branding-semibold-webfont.9d54019c.woff";